import { ref, computed } from 'vue'

export const collapsed = ref(true)
export const toggleSidebar = () => (collapsed.value = !collapsed.value)

export const mobileOpen = ref(false)
export const toggleMobileSidebar = () => (mobileOpen.value = !mobileOpen.value)

export const SIDEBAR_WIDTH = 150
export const SIDEBAR_WIDTH_COLLAPSED = 45

const isMobile = () => window.innerWidth <= 599

export const sidebarWidth = computed(
    () => {
        if (isMobile()) return '0px'
        return collapsed.value ? `${SIDEBAR_WIDTH_COLLAPSED}px` : `${SIDEBAR_WIDTH}px`
    }
)
